<script setup lang="ts">
import { computed } from "vue";
import { getEnvVar } from "@/utils/env";
import { useAppStore } from "@/stores/app";
import { useI18n } from "vue-i18n";

const { t, locale } = useI18n({ useScope: "global" });

const appStore = useAppStore();
const node_env = getEnvVar("MODE");
const baseUrl = getEnvVar("VITE_BASE_URL");
/*global __APP_BUILD__*/
/*eslint no-undef: "error"*/
// @ts-expect-error: TS2304 Need the global var
const app_build: string = __APP_BUILD__;
/*global __APP_VERSION__*/
/*eslint no-undef: "error"*/
// @ts-expect-error: TS2304 Need the global var
const app_version: string = __APP_VERSION__;
const appDescription = computed(() => {
  if (locale.value != "en") {
    return t("about.messages.app-description");
  }
  return appStore.appDesc;
});
</script>

<template>
  <div class="about">
    <h1>{{ $t("about.labels.title") }}</h1>
    <h3>{{ appDescription }}</h3>
    <h3>{{ $t("about.labels.hybris-site") }} {{ baseUrl }}</h3>
    <h3>{{ $t("about.labels.environment") }} {{ node_env }}</h3>
    <h3 class="app-build">{{ $t("about.labels.build") }} {{ app_build }}</h3>
    <h3 class="app-version">
      {{ $t("about.labels.version") }} {{ app_version }}
    </h3>
  </div>
</template>
